//
//
//
//
//
//
//
//
//

export default {
  name: "BluePaginationItem",
  props: ["index", "number", "goToPage", "isActive", "isNumber", "isEllipsis"],
  computed: {
    type() {
      return this.isActive(this.index) ? "span" : "button";
    },
    isNumberVisible() {
      return this.isNumber(this.index);
    },
    isEllipseVisible() {
      return this.isEllipsis(this.index);
    },
  },
};
